import { PayloadAction } from '@reduxjs/toolkit';
import { CompanyType } from 'types/company';
import { UserType } from 'types/user';

export interface AuthStateType {
  token: string | null;
  user: UserType | null;
  userType: 'company' | 'candidate' | null;
  hasCnpj: boolean;
  isAuthenticated: boolean;
  isLoadingAuth: boolean;
  company: CompanyType;
  requiredCompanyCompleted: boolean;
}

export enum AuthSagaActionsType {
  LOGIN = 'LOGIN',
  GOOGLE_LOGIN = 'GOOGLE_LOGIN',
  FACEBOOK_LOGIN = 'FACEBOOK_LOGIN',
  GET_USER = 'GET_USER',
  GET_COMPANY = 'GET_COMPANY'
}

export type LoginActionPayloadType = PayloadAction<{
  email: string;
  code: string;
  captchaToken: string;
  callback?: () => void;
}>;

export type LoginActionType = (
  email: string,
  code: string,
  captchaToken: string,
  callback?: () => void
) => LoginActionPayloadType;

export type GoogleLoginActionPayloadType = PayloadAction<{
  accessToken: string;
  isCompany: boolean;
  callback?: () => void;
}>;

export type GoogleLoginActionType = (
  accessToken: string,
  isCompany: boolean,
  callback?: () => void
) => GoogleLoginActionPayloadType;

export type FacebookLoginActionPayloadType = PayloadAction<{
  accessToken: string;
  isCompany: boolean;
  callback?: () => void;
}>;

export type FacebookLoginActionType = (
  accessToken: string,
  isCompany: boolean,
  callback?: () => void
) => FacebookLoginActionPayloadType;

export type GetUserActionPayloadType = PayloadAction<{
  token: string;
  callback?: () => void;
}>;

export type GetUserActionType = (
  token: string,
  callback?: () => void
) => GetUserActionPayloadType;
